import React from 'react';

import { useTranslation } from '../../../../../../../hooks';
import { T } from '../../../../../../../constants';
import { TopWinsTabKey } from '../top-wins-tabs';
import { GamesTabKey } from '../games-tabs';

import './style.scss';

interface TopWinsEmptyProps {
  activeGamesTab: GamesTabKey;
  activeTopWinsTab: TopWinsTabKey;
}

const EMPTY_MESSAGES = {
  [GamesTabKey.CurrentGame]: {
    [TopWinsTabKey.MyTopWins]: T.EMPTY_TOP_WINS_MY_CURRENT_GAME,
    [TopWinsTabKey.AllTopWins]: T.EMPTY_TOP_WINS_ALL_CURRENT_GAME
  },
  [GamesTabKey.AllGames]: {
    [TopWinsTabKey.MyTopWins]: T.EMPTY_TOP_WINS_MY_ALL_GAMES,
    [TopWinsTabKey.AllTopWins]: T.EMPTY_TOP_WINS_ALL_GAMES
  }
};

export const TopWinsEmpty: React.FC<TopWinsEmptyProps> = ({ activeGamesTab, activeTopWinsTab }) => {
  
  const t = useTranslation();

  return (
    <div className="leaderBoardEmptyBlock">
      <span className="icon-search-off leaderSearchIcon" />
      <p className="leaderBoardEmptyText">
        {t(EMPTY_MESSAGES[activeGamesTab][activeTopWinsTab])}
      </p>
    </div>
  );
};
